import { StaffApiService } from '@common/ApiService'
import paginationHeaders from '@/src/utils/pagination-headers'

const USER_SUCCESS = 'USER_SUCCESS'
const USERS_SUCCESS = 'USERS_SUCCESS'
const USER_ERROR = 'USER_ERROR'
const USER_PROGRESS = 'USER_PROGRESS'
const USER_CLEAR = 'USER_CLEAR'
const UPDATE_PAGINATION = 'UPDATE_PAGINATION'

export const state = {
  user: {},
  user_list: [],
  errors: {},
  pagination: {},
  progress: '',
}

export const getters = {}

export const mutations = {
  [USER_SUCCESS](state, data) {
    state.user = data
    return state
  },

  [USERS_SUCCESS](state, data) {
    state.user_list = data
    return state
  },

  [USER_PROGRESS](state, progress) {
    state.progress = progress
    return state.progress
  },

  [USER_ERROR](state, data) {
    state.errors = data
    state.progress = 'error'
    return state
  },

  [USER_CLEAR](state) {
    state.user = {}
    return state
  },

  [UPDATE_PAGINATION](state, response) {
    state.pagination = paginationHeaders(response)
    return state
  },
}

export const actions = {
  createUser({ commit }, newUser) {
    return StaffApiService.post(`v1/users`, {
      ...newUser,
    })
      .then((response) => {
        commit(USER_SUCCESS, response.data)
        if (response.status === 201) {
          commit(USER_ERROR, null)
        }
      })
      .catch((error) => commit(USER_ERROR, error))
  },

  updateUser({ commit }, user) {
    return StaffApiService.patch(`v1/users/${user.id}`, {
      ...user,
    })
      .then((response) => {
        commit(USER_SUCCESS, response.data)
        if (response.status === 200) {
          commit(USER_ERROR, null)
        }
      })
      .catch((error) => commit(USER_ERROR, error))
  },

  deleteUser({ commit }, user) {
    return StaffApiService.delete(`v1/users/${user.id}`, {
      ...user,
    }).catch((error) => commit(USER_ERROR, error))
  },

  getUser({ commit }, userRef) {
    return StaffApiService.get(`v1/users/${userRef}`).then((response) =>
      commit(USER_SUCCESS, response.data)
    )
  },

  fetchUsers({ commit }, query) {
    return new Promise((resolve) => {
      commit(USER_PROGRESS, 'search_loading')
      return StaffApiService.query('v1/users/search', {
        params: query,
      })
        .then((response) => {
          commit(USERS_SUCCESS, response.data)
          commit(USER_PROGRESS, 'users_success')
          commit(UPDATE_PAGINATION, response)
          resolve(response.data)
        })
        .catch((error) => commit(USER_ERROR, error))
    })
  },

  exportUsersList({ commit }, query) {
    return new Promise((resolve) => {
      return StaffApiService.query('v1/users/download', {
        params: query,
      })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => commit(USER_ERROR, error))
    })
  },
}
